module.exports = __webpack_public_path__ + "static/media/encerrada_poetas_estrada.3e74f9b2.jpg";